import {Component, inject, OnInit, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {ClpFormatPipe} from '@shared/pipes/clp/clp-format-pipe';
import {Router} from '@angular/router';
import {MatDialog, MatDialogModule} from '@angular/material/dialog';
import {MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar';
import {OrderReviewDialog} from './order-review-dialog/order-review-dialog';
import {FoodItem} from '@core/models';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {CatalogStore} from '@store/catalog.store';
import {SessionStore} from '@store/session.store';
import {CartStore} from '@store/cart.store';

import {ReactiveFormsModule} from '@angular/forms';
import {LucideMinus, LucidePlus, LucideShoppingBag, LucideTrash2} from '@lucide/angular';

@Component({
  selector: 'app-cart',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ClpFormatPipe,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinner,
    ReactiveFormsModule,
    LucideTrash2,
    LucideMinus,
    LucidePlus,
    LucideShoppingBag
  ],
  templateUrl: './cart.html',
  styleUrl: './cart.scss'
})
export class CartView implements OnInit {
  protected readonly store = inject(CatalogStore);
  protected readonly sessionStore = inject(SessionStore);
  protected readonly cartStore = inject(CartStore);
  protected updatingId = signal<number | null>(null);
  private readonly dialog = inject(MatDialog);
  private readonly router = inject(Router);
  private readonly snackBar = inject(MatSnackBar);

  ngOnInit() {
    this.store.setBackRoute('/standard/categories');


  }

  changeQty(cartLineItemId: string | undefined, delta: number) {
    if (cartLineItemId) this.cartStore.updateQuantity(cartLineItemId, delta);
    setTimeout(() => this.updatingId.set(null), 300);
  }

  removeItem(cartLineItemId: string | undefined) {
    if (cartLineItemId) this.cartStore.removeFromCart(cartLineItemId);
  }

  parsePrice(price: string): number {
    return parseFloat(price);
  }

  confirmOrder() {

    const dialogRef = this.dialog.open(OrderReviewDialog, {
      width: '90%',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe((updatedItems: FoodItem[] | null) => {
      if (updatedItems) {
        updatedItems.forEach(item => {
          this.cartStore.updateNotes(item.cartLineItemId!, item.notes || '');
        });

        this.cartStore.placeOrder({
          onSuccess: (status) => {
            this.snackBar.open(status || 'Pedido confirmado', 'Cerrar', {
              duration: 3000,
              panelClass: ['toast-success'],
              verticalPosition: 'top'
            });
            this.router.navigate(['/standard/tracking']);
          },
          onError: (_) => {
            this.snackBar.open('La orden ha cambiado o se encuentra bloqueada. Sincronizando...', 'Cerrar', {
              duration: 4000,
              panelClass: ['toast-error'],
              verticalPosition: 'top'
            });
            this.sessionStore.loadOrderStatusSession();
          }
        });
      }
    });
  }
}
